(function () {
  var open = document.getElementById('menuOpen');
  var close = document.getElementById('menuClose');
  var drawer = document.getElementById('mobileDrawer');
  if (!open || !close || !drawer) return;

  function show() {
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('menu-open');
  }
  function hide() {
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('menu-open');
  }

  open.addEventListener('click', show);
  close.addEventListener('click', hide);
  drawer.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', hide); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
})();

/* Tiny qty stepper used on PDP. Updates the hidden quantity input. */
(function () {
  document.querySelectorAll('[data-qty]').forEach(function (root) {
    var input = root.querySelector('input[type="number"]');
    var dec = root.querySelector('[data-qty-dec]');
    var inc = root.querySelector('[data-qty-inc]');
    if (!input || !dec || !inc) return;
    function clamp(v) {
      var min = parseInt(input.min || '1', 10);
      var max = parseInt(input.max || '99', 10);
      v = isNaN(v) ? min : v;
      return Math.max(min, Math.min(max, v));
    }
    dec.addEventListener('click', function () { input.value = clamp(parseInt(input.value, 10) - 1); input.dispatchEvent(new Event('change', { bubbles: true })); });
    inc.addEventListener('click', function () { input.value = clamp(parseInt(input.value, 10) + 1); input.dispatchEvent(new Event('change', { bubbles: true })); });
  });
})();

/* PDP thumbnail swap. Click a thumb, swap the main-img background. */
(function () {
  var main = document.querySelector('[data-main-img]');
  var thumbs = document.querySelectorAll('[data-thumb]');
  if (!main || !thumbs.length) return;
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      thumbs.forEach(function (x) { x.classList.remove('on'); });
      t.classList.add('on');
      var src = t.getAttribute('data-src');
      if (src) main.style.backgroundImage = "url('" + src + "')";
    });
  });
})();
